(() => {
  const root = document.querySelector('[data-comfort-compare]');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = 'true';

  // Keep a gallery swipe from following the Oxygen backing photograph link.
  const gallery = root.closest('.ss-approved-pdp')?.querySelector('.ss-main-media');
  if (gallery?.querySelector('[data-oxygen-gallery-link]')) {
    let gesture = null;
    let suppressClickUntil = 0;
    gallery.addEventListener('pointerdown', event => {
      if (!event.isPrimary || event.button !== 0) return;
      suppressClickUntil = 0;
      gesture = event.target.closest('[data-oxygen-gallery-link]')
        ? {id:event.pointerId, x:event.clientX, y:event.clientY, moved:false}
        : null;
    }, {passive:true});
    const track = event => {
      if (!gesture || gesture.id !== event.pointerId) return;
      if (Math.hypot(event.clientX - gesture.x, event.clientY - gesture.y) > 10) gesture.moved = true;
    };
    gallery.addEventListener('pointermove', track, {passive:true});
    gallery.addEventListener('pointerup', event => {
      track(event);
      if (!gesture || gesture.id !== event.pointerId) return;
      if (gesture.moved) suppressClickUntil = Date.now() + 700;
      gesture = null;
    }, {passive:true});
    gallery.addEventListener('pointercancel', () => {
      if (gesture) suppressClickUntil = Date.now() + 700;
      gesture = null;
    }, {passive:true});
    gallery.addEventListener('click', event => {
      if (event.detail > 0 && Date.now() < suppressClickUntil && event.target.closest('[data-oxygen-gallery-link]')) {
        event.preventDefault();
        suppressClickUntil = 0;
      }
    }, true);
  }
  const videos = [...root.querySelectorAll('[data-comfort-video]')];
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const visible = new Set();
  const manuallyPaused = new Set();
  const load = video => {
    if (!video.getAttribute('src')) {
      video.src = video.dataset.videoUrl;
      video.load();
    }
  };
  const play = video => {
    load(video);
    return video.play().catch(() => {});
  };
  videos.forEach(video => {
    const button = video.closest('[data-comfort-toggle]');
    const sync = () => {
      const action = video.paused ? 'Play' : 'Pause';
      button.setAttribute('aria-label', action + ' ' + button.dataset.productName + ' video');
    };
    video.muted = true;
    video.autoplay = !reducedMotion.matches;
    const toggle = () => {
      if (button.getAttribute('aria-disabled') === 'true') return;
      if (video.paused) {
        manuallyPaused.delete(video);
        play(video);
      } else {
        manuallyPaused.add(video);
        video.pause();
      }
    };
    button.addEventListener('click', toggle);
    button.addEventListener('keydown', event => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        toggle();
      }
    });
    video.addEventListener('play', sync);
    video.addEventListener('pause', sync);
    video.addEventListener('error', () => {
      button.setAttribute('aria-label', button.dataset.productName + ' video unavailable');
      button.setAttribute('aria-disabled', 'true');
    });
    sync();
  });
  const resumeVisible = () => {
    if (document.hidden || reducedMotion.matches) return;
    visible.forEach(video => { if (!manuallyPaused.has(video)) play(video); });
  };
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) videos.forEach(video => video.pause());
    else resumeVisible();
  });
  reducedMotion.addEventListener('change', () => {
    videos.forEach(video => { video.autoplay = !reducedMotion.matches; video.pause(); });
    resumeVisible();
  });
  if ('IntersectionObserver' in window) {
    const visibility = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const video = entry.target;
        if (entry.isIntersecting && entry.intersectionRatio >= 0.15) {
          visible.add(video);
          load(video);
          if (!document.hidden && !reducedMotion.matches && !manuallyPaused.has(video)) play(video);
        } else {
          visible.delete(video);
          video.pause();
        }
      });
    }, {threshold:[0,0.15]});
    videos.forEach(video => visibility.observe(video));
  } else {
    videos.forEach(video => { visible.add(video); load(video); });
    resumeVisible();
  }
  const rail = root.querySelector('.ss-comfort-compare__rail');
  const cards = [...root.querySelectorAll('[data-comfort-card]')];
  const previous = root.querySelector('[data-comfort-previous]');
  const next = root.querySelector('[data-comfort-next]');
  const position = root.querySelector('[data-comfort-position]');
  const index = () => cards.reduce((best, card, i) =>
    Math.abs(card.getBoundingClientRect().left - rail.getBoundingClientRect().left) <
    Math.abs(cards[best].getBoundingClientRect().left - rail.getBoundingClientRect().left) ? i : best, 0);
  const update = () => {
    const i = index();
    position.textContent = (i + 1) + ' of ' + cards.length;
    previous.disabled = i === 0;
    next.disabled = i === cards.length - 1;
  };
  const move = delta => {
    const target = cards[Math.max(0, Math.min(cards.length - 1, index() + delta))];
    const offset = target.getBoundingClientRect().left - rail.getBoundingClientRect().left;
    rail.scrollBy({left:offset,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
  };
  previous.addEventListener('click', () => move(-1));
  next.addEventListener('click', () => move(1));
  rail.addEventListener('scroll', update, {passive:true});
  window.addEventListener('resize', update);
  update();
})();

